import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import BrandLogo from "./BrandLogo";

const KEY = "regenx_age_verified_v1";

export default function AgeGateModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setOpen(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "1");
    setOpen(false);
  };

  const decline = () => {
    window.location.href = "https://www.google.com";
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-secondary/85 backdrop-blur-md px-4"
      data-testid="age-gate-modal"
    >
      <div className="max-w-lg w-full bg-background border border-border p-10 md:p-14 animate-fade-up">
        <div className="flex justify-center mb-8">
          <BrandLogo variant="full" iconSize={64} />
        </div>
        <div className="h-px w-12 bg-primary mx-auto mb-8" aria-hidden="true" />
        <p className="overline text-primary mb-4 text-center" data-testid="age-gate-eyebrow">
          Age verification
        </p>
        <h2 className="editorial-heading text-3xl md:text-4xl mb-6 text-foreground text-center">
          Are you 18 or older?
        </h2>
        <p className="text-sm md:text-base text-muted-foreground leading-relaxed mb-8 text-center">
          The compounds offered on RegenX Wellness are sold strictly for
          <strong className="text-foreground"> laboratory and research purposes</strong>. They
          are not intended for human or veterinary consumption. By entering, you confirm you
          are at least 18 years of age and a qualified researcher.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            onClick={accept}
            data-testid="age-gate-accept"
            className="flex-1 rounded-none bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground uppercase tracking-[0.18em] text-xs py-6"
          >
            I am 18+ — Enter
          </Button>
          <Button
            onClick={decline}
            variant="outline"
            data-testid="age-gate-decline"
            className="flex-1 rounded-none border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground uppercase tracking-[0.18em] text-xs py-6"
          >
            Leave site
          </Button>
        </div>
      </div>
    </div>
  );
}
